module.exports = __webpack_public_path__ + "341b20d177cbeaaf9fee9d96640bee0c.pdf";